module.exports = __webpack_public_path__ + "img/toucharcade_review3_part2.7f0761c3.png";